<template>
  <div>
    <v-text-field
      placeholder="Cautare"
      hint="Se cauta dupa id_scoala, adresa, observatii adresa si observatii"
      clearable
      persistent-hint
      append-icon="mdi-magnify"
      solo
      :loading="loading"
      single-line
      @click:append="_cbSearch"
      @keydown.enter="_cbSearch"
      :suffix="total"
      v-model="searchTerm">
    </v-text-field>

    <v-card flat>
      <v-card-title class="pb-0">
        <v-subheader>Poze</v-subheader>

        <v-scale-transition appear group>
          <v-avatar size="22" class="mx-1" @click="toggleDone" key="done" :title="done === null ? 'Done si Not Done' : (done === 1 ? 'Done' : 'Not Done')">
            <v-icon :color="doneColor">
              {{done === null ? 'mdi-check-circle-outline' : (done === 1 ? 'mdi-check-circle' : 'mdi-close-circle')}}
            </v-icon>
          </v-avatar>

          <v-avatar size="22" class="mx-1" @click="togglePhotos" key="toggle-photos" :title="photos === null ? 'Cu si Fara Poze' : (photos === 1 ? 'Cu Poze' : 'Fara Poze')">
            <v-icon :color="photosColor">
              {{photos === null ? 'mdi-camera-outline' : (photos === 1 ? 'mdi-camera' : 'mdi-camera-off')}}
            </v-icon>
          </v-avatar>

          <!-- <v-avatar size="22" class="mx-1" @click="togglePdfs" key="toggle-pdfs" :title="pdfs === null ? 'Cu si Fara Pdf-uri' : (pdfs === 1 ? 'Cu Pdf-uri' : 'Fara Pdf-uri')">
            <v-icon :color="pdfsColor">
              {{pdfs === null ? 'mdi-file-pdf-outline' : (pdfs === 1 ? 'mdi-file-pdf' : 'mdi-file-pdf')}}
            </v-icon>
          </v-avatar> -->

        </v-scale-transition>

        <v-spacer></v-spacer>
        <v-btn flat icon color="blue-grey" @click="toggleCollapsed" small :ripple="false">
          <v-icon small>{{collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up'}}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
        <!-- <v-fade-transition appear group mode="out-in"> -->
          <template v-for="item in items" >
            <details :key="item._id" class="my-2" :open="!collapsed">
              <summary>
                {{item.id_scoala}} &nbsp;

                <v-scale-transition appear group tag="div" style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                  <v-avatar size="16" @click.stop.prevent :key="item._id + 'type'" :title="item.id_scoala">
                    <v-img :src="getItemType(item)"></v-img>
                  </v-avatar>

                  <v-btn small class="ma-0" icon flat v-if="item.done" @click.stop.prevent :key="item._id + 'done'" title="Done" :ripple="false">
                    <v-icon small color="primary">mdi-check</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0" icon flat v-else @click.stop.prevent :key="item._id + 'notdone'" title="Not done" :ripple="false">
                    <v-icon small color="error">mdi-close</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0 mr-1 pa-0" icon flat v-if="item.photos.length" @click.stop.prevent style="min-width: 0" :key="item._id + 'photos-off'" title="Poze incarcate" :ripple="false">
                    <v-icon small color="primary">mdi-image</v-icon>
                    {{item.photos.length}}
                  </v-btn>
                  <v-btn small class="ma-0 mr-1 pa-0" icon flat v-else @click.stop.prevent style="min-width: 0" :key="item._id + 'photos-on'" title="Nu exista poze" :ripple="false">
                    <v-icon small color="error" class="mr-0">mdi-image-off</v-icon>
                    {{item.photos.length}}
                  </v-btn>
                  <!-- <v-btn small class="ma-0 mr-1 pa-0" icon flat v-if="item.pdfs.length" @click.stop.prevent style="min-width: 0" :key="item._id + 'pdfs-off'" title="Pdf-uri incarcate" :ripple="false">
                    <v-icon small color="primary">mdi-file-pdf</v-icon>
                    {{item.pdfs.length}}
                  </v-btn>
                  <v-btn small class="ma-0 mr-1 pa-0" icon flat v-else @click.stop.prevent style="min-width: 0" :key="item._id + 'pdfs-on'" title="Nu exista pdf-uri" :ripple="false">
                    <v-icon small color="error" class="mr-0">mdi-file-pdf</v-icon>
                    {{item.pdfs.length}}
                  </v-btn> -->
                  <v-btn small class="ma-0 mr-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :key="item._id + 'lenqbtn'" title="Poze in asteptare" :ripple="false">
                    <v-icon small :color="filesInQueue(item._id) ? 'primary' : 'blue-grey'" class="mr-1">mdi-cloud-upload</v-icon>
                    {{filesInQueue(item._id)}}
                  </v-btn>

                  <v-spacer :key="item._id + 'spacer'"></v-spacer>

                  <!-- <v-btn
                    class="ma-0 pa-0 mr-2"
                    flat
                    @click.stop.prevent="_cbAddPhoto(item._id)"
                    v-if="user && !user.dummy"
                    :key="item._id + 'add'"
                    style="min-width: 0"
                    title="Adauga poze">
                    <v-icon color="primary" :size="18">mdi-plus-circle</v-icon>
                    <v-icon color="primary" :size="18">mdi-camera</v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-0 pa-0 mr-2"
                    flat
                    @click.stop.prevent="_cbAddPdf(item._id)"
                    v-if="user && !user.dummy"
                    :key="item._id + 'addpdf'"
                    style="min-width: 0"
                    title="Adauga pdf-uri">
                    <v-icon color="primary" :size="18">mdi-plus-circle</v-icon>
                    <v-icon color="primary" :size="18">mdi-file-pdf</v-icon>
                  </v-btn> -->
                  <template v-if="user && user.admin">
                    <v-btn
                      small
                      class="ma-0 pa-0"
                      icon
                      flat @click.stop.prevent="_cbToggleDeleteMode(item._id)"
                      :key="item._id + 'delete'"
                      style="min-width: 0"
                      :title="deleteEnabled ? 'Iesi din modul de stergere' : 'Activeaza modul de stergere'"
                      :ripple="false">
                      <v-icon :color="deleteEnabled && deleteEntity === item._id ? 'error' : 'blue-grey'" :size="18">mdi-delete-circle</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      class="ma-0 pa-0"
                      icon
                      flat
                      @click.stop.prevent="_cbConfirmDelete"
                      v-if="deleteEnabled && toDelete.length && deleteEntity === item._id"
                      :key="item._id + 'confirm'"
                      style="min-width: 0"
                      title="Sterge pozele selectate"
                      :ripple="false">
                      <v-icon color="error" :size="18">mdi-check-circle</v-icon>
                    </v-btn>
                    <span v-if="deleteEnabled && toDelete.length && deleteEntity === item._id" :key="item._id + 'lenq'">
                      {{toDelete.length}}
                    </span>
                  </template>
                </v-scale-transition>
              </summary>

              {{item.adresa}}

              <p class="my-2">Poze:</p>

              <viewer v-if="!deleteEnabled || deleteEntity !== item._id" :options="{url: 'data-src', backdrop: 'static'}" :key="item._id">
                <template>
                  <v-layout align-center justify-flex-start wrap>
                    <v-scale-transition group tag="div" style="display: flex; flex-wrap: wrap; justify-content: space-between">
                      <template v-for="(photo, pIndex) in item.photos">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px; border: thin solid #ccc; border-radius: 10px" :key="photo + pIndex" class="ma-1">
                          <v-avatar
                            size="48"
                            class="ma-1 viewerPhoto"
                            style="box-sizing: border-box">
                            <img
                              :src="serverURL + photo.replace('photos', 'thumbs')"
                              :data-src="serverURL + photo"
                              class="pa-1">
                          </v-avatar>
                          <span  style="max-width: 72px; overflow: hidden; word-break: break-all; text-align: center" :title="photo">
                            {{ photo.split('_')[1] }}
                          </span>
                          <v-spacer></v-spacer>
                          <v-divider style="width: 100%"></v-divider>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </v-scale-transition>
                  </v-layout>
                </template>
              </viewer>
              <v-layout v-if="deleteEnabled && deleteEntity === item._id" align-center justify-flex-start wrap :key="item._id">
                <v-scale-transition group tag="div" style="display: flex; flex-wrap: wrap; justify-content: space-between">
                  <div
                    v-for="(photo, pIndex) in item.photos"
                    :key="photo + pIndex"
                    style="display: flex; flex-direction: column; align-items: center; width: 64px; border-radius: 10px"
                    class="ma-1"
                    :style="{ border: `thin ${toDelete.includes(photo) ? 'solid' : 'dashed'} ${toDelete.includes(photo) ? '#f44336' : '#ccc'}` }">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                    <span style="max-width: 72px; overflow: hidden; word-break: break-all; text-align: center" :title="photo">
                      {{ photo.split('_')[1] }}
                    </span>
                  </div>
                </v-scale-transition>
              </v-layout>

              <!-- <p class="my-2">PDF-uri:</p>

              <template v-if="!deleteEnabled || deleteEntity !== item._id">
                <v-layout align-center justify-flex-start wrap>
                  <v-scale-transition group tag="div" style="display: flex; flex-wrap: wrap">
                    <template v-for="(pdf, pIndex) in item.pdfs">
                      <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                        <v-avatar
                          color="primary"
                          size="48"
                          class="ma-1"
                          style="box-sizing: border-box">
                          <v-icon class="pa-1">mdi-file-pdf</v-icon>
                        </v-avatar>
                        <span class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">
                          {{ pdf.split('_')[1] }}
                        </span>
                        <div style="display: flex; justify-content: space-around; width: 100%">
                          <a :href="serverURL + pdf + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca pdf">
                            <v-icon small>mdi-download</v-icon>
                          </a>
                          <a @click.stop="viewPdf(pdf, serverURL + pdf + '?buster=' + new Date().getTime())" style="text-decoration: none" title="Deschide pdf">
                            <v-icon small>mdi-eye</v-icon>
                          </a>
                        </div>
                      </div>
                    </template>
                  </v-scale-transition>
                </v-layout>
              </template>
              <template v-if="deleteEnabled && deleteEntity === item._id">
                <v-layout align-center justify-flex-start wrap :key="item.id">
                  <v-scale-transition group tag="div" style="display: flex; flex-wrap: wrap">
                    <template v-for="(pdf, pIndex) in item.pdfs">
                      <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                        <v-avatar
                          :color="toDelete.includes(pdf) ? 'error' : ''"
                          size="48"
                          :key="pdf + pIndex"
                          class="ma-1"
                          :class="{ 'deletePdf': toDelete.includes(pdf), 'normalPdf': !toDelete.includes(pdf) }"
                          style="box-sizing: border-box"
                          @click="selectPdf(pdf)">
                          <v-icon class="pa-1">
                            mdi-file-pdf
                          </v-icon>
                        </v-avatar>
                        <span :key="pdf + pIndex + 'pdf'" class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">
                          {{ pdf.split('_')[1] }}
                        </span>
                      </div>
                    </template>
                  </v-scale-transition>
                </v-layout>
              </template> -->
            </details>
            <v-progress-linear v-if="uploading.state && entity === item._id" :value="uploading.value" height="22" :key="item._id + 'loader'">
              <span class="pl-2"> {{uploading.done}} din {{uploading.total}} ({{uploading.totalFilesDone}} din {{uploading.totalFiles}} poze)</span>
            </v-progress-linear>
            <v-divider :key="item._id + 'divider'"></v-divider>
          </template>
        <!-- </v-fade-transition> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-pagination
          style="justify-content: center"
          v-model="page"
          :length="totalPages"
          circle
        ></v-pagination>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <form ref="form">
      <input type="file" ref="fileinput" accept="image/*" multiple @change="filesAdded" style="display: none">
    </form>
    <form ref="pdfform">
      <input type="file" ref="pdffileinput" accept="application/pdf" multiple @change="pdfFilesAdded" style="display: none">
    </form>

    <v-dialog v-model="pdfDialog" fullscreen hide-overlay :transition="false" no-click-animation>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="pdfDialog = false" :ripple="false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ pdfFrameTitle }}
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text style="height: calc(100vh - 70px)" class="pa-0">
          <iframe :src="pdfFrameSrc" frameborder="0" width="100%" height="100%"></iframe>

          <!-- <embed :src="pdfFrameSrc" type="application/pdf" style="overflow: auto; width: 100%; height: 100%;"> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'
// import prettyBytes from 'pretty-bytes'

export default {
  name: 'photos',
  components: { Viewer },
  data: () => ({
    search: '',
    toDelete: [],
    deleteEnabled: false,
    deleteEntity: null,
    collapsed: false,
    entity: null,
    uploading: {
      state: false,
      value: 0,
      done: 0,
      total: 0,
      totalFiles: 0,
      totalFilesDone: 0
    },
    pdfDialog: false,
    pdfFrameTitle: '',
    pdfFrameSrc: ''
  }),
  computed: {
    serverURL () {
      return this.$store.getters.serverURL
    },
    searchTerm: {
      get () {
        return this.$store.getters['entities/search']
      },
      set (value) {
        this.search = value
        if (!value) {
          this._cbSearch()
        }
      }
    },
    user () {
      return this.$store.getters.user
    },
    items () {
      return this.$store.getters['entities/items']
    },
    total () {
      return String(this.$store.getters['entities/total'])
    },
    page: {
      get () {
        return this.$store.getters['entities/page']
      },
      set (value) {
        this.$store.dispatch('entities/setPage', value)
      }
    },
    totalPages () {
      return this.$store.getters['entities/totalPages']
    },
    filters () {
      return this.$store.getters['entities/filters']
    },
    done () {
      return this.$store.getters['entities/done']
    },
    photos () {
      return this.$store.getters['entities/photos']
    },
    pdfs () {
      return this.$store.getters['entities/pdfs']
    },
    doneColor () {
      if (this.done === 1) return 'primary'
      if (this.done === -1) return 'error'
      return 'blue-grey'
    },
    photosColor () {
      if (this.photos === 1) return 'primary'
      if (this.photos === -1) return 'error'
      return 'blue-grey'
    },
    pdfsColor () {
      if (this.pdfs === 1) return 'primary'
      if (this.pdfs === -1) return 'error'
      return 'blue-grey'
    },
    loading () {
      return this.$store.getters.loading
    },
    files () {
      return this.$store.getters['entities/files']
    }
  },
  methods: {
    filesInQueue (entity) {
      return this.files.filter(file => file.entity === entity && !file.uploaded).length
    },
    toggleDone () {
      this.$store.dispatch('entities/toggleDone')
    },
    togglePhotos () {
      this.$store.dispatch('entities/togglePhotos')
    },
    togglePdfs () {
      this.$store.dispatch('entities/togglePdfs')
    },
    toggleFilter (filter) {
      this.$store.dispatch('entities/toggleFilter', filter)
    },
    getItemType (marker) {
      if (marker.done) return '/svg/done.svg'
      return marker.user ? '/svg/edited.svg' : '/svg/unedited.svg'
    },
    _cbAddPhoto (entity) {
      this.entity = entity
      this.$refs.fileinput.click()
    },
    _cbAddPdf (entity) {
      this.entity = entity
      this.$refs.pdffileinput.click()
    },
    async filesAdded (e) {
      let filesArray = Array.from(e.target.files)
      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.entity, tip: 'photo' })
      this.$refs.form.reset()
    },
    async pdfFilesAdded (e) {
      let filesArray = Array.from(e.target.files)
      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.entity, tip: 'pdf' })
      this.$refs.pdfform.reset()
    },
    selectPhoto (photo) {
      const index = this.toDelete.findIndex(p => p === photo)
      if (index > -1) {
        this.toDelete.splice(index, 1)
      } else {
        this.toDelete.push(photo)
      }
    },
    selectPdf (pdf) {
      const index = this.toDelete.findIndex(p => p === pdf)
      if (index > -1) {
        this.toDelete.splice(index, 1)
      } else {
        this.toDelete.push(pdf)
      }
    },
    toggleCollapsed () {
      this.collapsed = !this.collapsed
    },
    _cbToggleDeleteMode (entity) {
      if (this.deleteEnabled && this.deleteEntity === entity) {
        this.deleteEnabled = false
        this.deleteEntity = null
        return
      }

      if (this.deleteEnabled && this.deleteEntity !== entity) {
        this.deleteEntity = entity
        return
      }

      if (!this.deleteEnabled) {
        this.deleteEnabled = true
        this.deleteEntity = entity
      }

      this.toDelete = []
    },
    _cbSearch () {
      this.$nextTick(() => {
        this.$store.dispatch('entities/search', this.search)
      })
    },
    _cbConfirmDelete () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva?'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          const photos = this.toDelete.filter(item => item.startsWith('/photos/'))
          const pdfs = this.toDelete.filter(item => item.startsWith('/pdfs/'))

          if (photos.length) {
            this.$store.dispatch('entities/deletePhotos', { entity: this.deleteEntity, photos })
          }
          if (pdfs.length) {
            this.$store.dispatch('entities/deletePdfs', { entity: this.deleteEntity, pdfs })
          }
          this.deleteEntity = null
          this.toDelete = []
        })
        .catch(() => {
        })
    },
    viewPdf (pdf, src) {
      this.pdfFrameSrc = src
      this.pdfFrameTitle = pdf.replace('/pdfs/', '')
      this.pdfDialog = true
    }
  },
  mounted () {
    if (this.searchTerm) {
      this.search = this.searchTerm
    }
  }
}
</script>

<style>

</style>
